import { normalizeDashboards } from '../../../../utils'
import { ensureUniqueObjectIds } from '@edge/spark/utils'
import { setActiveDashboardId } from '../../../../Stores'
import { DASHBOARD_LIMIT } from '../../../../constants'
import {
    ClientUserDashboardsDocument as query,
    type ClientUserDashboardsQuery,
    type MutationResolvers,
    UpdateUserDashboardsDocument as mutation,
    type UpdateUserDashboardsMutation,
} from '../../../../generated/graphql'
import { createDialog } from '@edge/spark/feature-dialog'
import type { ApolloResolverContext } from '@edge/spark/io-apollo'
import { EmptyDashboardLayout } from '../../../../EmptyDashboardLayout'
import { getActiveAuctionId } from '@edge/spark/io-roles'

const TWELVE_CHAR_HEX_MAX = 281474976710656 // parseInt(1e12, 16)

const randomDefaultId = (): string =>
    `00000000-0000-1000-8000-${Math.floor(Math.random() * TWELVE_CHAR_HEX_MAX).toString(16)}`

const createDashboard: MutationResolvers<ApolloResolverContext>['createDashboard'] = async (
    _root,
    { userId, name },
    { client },
) => {
    console.debug('io-dashboards createDashboard Deprecated, refactor (soon)')

    if (!client) {
        throw new Error('Missing ApolloClient')
    }

    const { data } = await client.query<ClientUserDashboardsQuery>({
        query,
        variables: { userId },
        fetchPolicy: 'network-only',
    })

    const savedDashboards = normalizeDashboards(data.dashboards)

    if (savedDashboards.length >= DASHBOARD_LIMIT) {
        createDialog({
            message: `Limit ${DASHBOARD_LIMIT} Dashboards`,
            timeout: 5000,
        })

        return false
    }

    const emptyDashboardWithName = {
        ...EmptyDashboardLayout,
        name,
    }

    const activeDashboardId = randomDefaultId()
    const updatedDashboard = {
        ...emptyDashboardWithName,
        id: activeDashboardId,
    }
    const updatedDashboards = savedDashboards.concat(updatedDashboard)
    const cleanedDashboards = ensureUniqueObjectIds(updatedDashboards)
    const stringifiedUpdatedDashboards = cleanedDashboards.map((d) => JSON.stringify(d))

    const auctionId = getActiveAuctionId()
    const admin = userId ? { auctionId, subjectUserId: userId } : undefined

    await client.mutate<UpdateUserDashboardsMutation>({
        mutation,
        variables: { admin, dashboards: stringifiedUpdatedDashboards },
        optimisticResponse: {
            updateUser: {
                __typename: 'UserMutationResponse',
                authenticationId: null,
                statusCode: 200,
                statusMessage: null,
            },
        },
        update: (store): void => {
            setActiveDashboardId(activeDashboardId)
            store.writeData({
                data: {
                    'dashboards({})': stringifiedUpdatedDashboards,
                    user: {
                        __typename: 'User',
                        dashboards: stringifiedUpdatedDashboards,
                    },
                },
            })
        },
    })

    createDialog({
        message: `Created ${name ? ` '${name}'` : ''} dashboard`,
        timeout: 5000,
    })

    return true
}

export default createDashboard
